module.exports = __webpack_public_path__ + "assets/3-Chicago-Technology-Sales-Headhunters.39986f4a.png";